import { Component, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { Subscription } from "rxjs";
import { EventCategory } from "src/app/classes/calendar";
import { CalendarService } from "src/app/services/calendar.service";
import { InfoDialogComponent } from "@trivelope/triv-ui-tools-lib";
import { DynamicFormEditorService } from "src/app/services/dynamic-form-editor.service";
import { MatDialog } from "@angular/material/dialog";
import { QuestionService } from "src/app/services/question.service";


@Component( {
	standalone: true,
	selector: "dynamic-form-manager",
	templateUrl: "./dynamic-form-manager.component.html",
	styleUrl: "./dynamic-form-manager.component.scss",
	imports: [ MatButtonModule, RouterModule, MatProgressSpinnerModule, MatIconModule ]
})
export class DynamicFormManagerComponent implements OnInit {
	

	subscriptions = new Subscription();
	bLoading = true;
	bDeletingOne = false;
	bDeleting: { [key: string]: boolean } = {};
	bDeleteError = false;

	forms: EventCategory[] = [];

	
	constructor(
		private calendarService: CalendarService,
		private dynamicFormEditorService: DynamicFormEditorService,
		private matDialog: MatDialog,
		private questionService: QuestionService
	) {}


	ngOnInit() {

		this.calendarService.getCategories().subscribe( categories => {
			this.bLoading = false;
			this.forms = categories;
		});
		
	}

	ngOnDestroy() {
		
		this.subscriptions.unsubscribe();

	}


	clickDeleteForm( formId: string ) {

		this.bDeleting[ formId ] = true;
		this.bDeletingOne = true;

		this.questionService.isFormDeletable( formId ).subscribe( b => {

			if( !b ) {
				this.bDeleting[ formId ] = false;
				this.bDeletingOne = false;
				if( b !== null ) {
					this.matDialog.open( InfoDialogComponent, {
						data: 'Das Formular ist noch in einer Veranstaltung benutzt'
					});
				}
				return;
			}

			this.dynamicFormEditorService.deleteFormAndQuestions( formId ).subscribe( b => {

				this.bDeleting[ formId ] = false;
				this.bDeletingOne = true;
				this.bDeleteError = !b;
	
				if( b ) {
					const i = this.forms.findIndex( f => f.fkId == formId );
					if( i != -1 ) {
						this.forms.splice( i, 1 );
					}
				}
	
			} );	

		} );

	}

}